import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getPortfolioRecommndationMetrics } from 'gqlQueries/priceSimulator';
import { fetchPortfolioRecommendationMetricsParser } from 'parser/priceSimulator/priceSimulatorDataParser';
const errorMessage: string = 'Something went wrong!';

function useFetchPortfolioRecommendationMetrics() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);

    const [fetchPortfolioRecommendationMetrics] = useLazyQuery(getPortfolioRecommndationMetrics, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'network-only',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPortfolioRecommendationMetrics } = payload;
            //if data present parse it
            if (getPortfolioRecommendationMetrics?.length > 0) {
                const parsedData = fetchPortfolioRecommendationMetricsParser(getPortfolioRecommendationMetrics);
                setData(parsedData);
                return;
            }
            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPortfolioRecommendationMetrics: (variables: any) => {
            setLoading(true);
            setError(null);
            fetchPortfolioRecommendationMetrics(variables);
        },
    };
}

export { useFetchPortfolioRecommendationMetrics };
